// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.explorer-item {
    padding: 20px;
    width: 100px;
    /*border: 1px solid black;
    border-radius: 10px;*/
    margin: 7px;
    /*-webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
    -moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
    box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);*/
    cursor:pointer;
}
    .explorer-item:hover {
        padding: 18px;
        border: 2px solid #c6e067;
    }

.explorer-wrapper {
    margin: 10px;
    max-width: 100%;
    overflow: hidden;
    color: white;
}

.breadcrumb {
    cursor:pointer;
}
.breadcrumb:hover {
    color: var(--primary-color) !important;
}
.explorer-content {
    overflow: auto;
}
.preview {
    max-width: 100px;
    max-height: 100px;
}
.filename {
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.active {
    padding: 18px;
    border: 2px solid #c6e067;
}
.active:hover {
    padding: 18px;
    border: 2px solid #c6e067;
}

input[type="file"] {
    display: none;
}

.custom-file-upload {
    padding: 0;
    min-width: 0;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    line-height: 40px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    text-align: center;
    align-content: center;
    flex-direction: column;
    align-self: center;
}
.file-upload{
    margin-top:8px;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/fileexplorer/fileexplorer.control.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,YAAY;IACZ;yBACqB;IACrB,WAAW;IACX;;oDAEgD;IAChD,cAAc;AAClB;IACI;QACI,aAAa;QACb,yBAAyB;IAC7B;;AAEJ;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,cAAc;AAClB","sourcesContent":[".explorer-item {\n    padding: 20px;\n    width: 100px;\n    /*border: 1px solid black;\n    border-radius: 10px;*/\n    margin: 7px;\n    /*-webkit-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);\n    -moz-box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);\n    box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);*/\n    cursor:pointer;\n}\n    .explorer-item:hover {\n        padding: 18px;\n        border: 2px solid #c6e067;\n    }\n\n.explorer-wrapper {\n    margin: 10px;\n    max-width: 100%;\n    overflow: hidden;\n    color: white;\n}\n\n.breadcrumb {\n    cursor:pointer;\n}\n.breadcrumb:hover {\n    color: var(--primary-color) !important;\n}\n.explorer-content {\n    overflow: auto;\n}\n.preview {\n    max-width: 100px;\n    max-height: 100px;\n}\n.filename {\n    font-size: 10px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.active {\n    padding: 18px;\n    border: 2px solid #c6e067;\n}\n.active:hover {\n    padding: 18px;\n    border: 2px solid #c6e067;\n}\n\ninput[type=\"file\"] {\n    display: none;\n}\n\n.custom-file-upload {\n    padding: 0;\n    min-width: 0;\n    width: 40px;\n    height: 40px;\n    flex-shrink: 0;\n    line-height: 40px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    align-content: center;\n    flex-direction: column;\n    align-self: center;\n}\n.file-upload{\n    margin-top:8px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
